var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-home"},[_c('chain-info'),_c('k-line',{attrs:{"showY":false}}),_c('view-block',{attrs:{"ListLength":4}}),_c('view-tx',{attrs:{"ListLength":4}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }